/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A flexible carousel UI component for VDK Web. (@accedo/vdkweb-carousel) 6.0.4
* 
*******************************************************************************/
import React from 'react';
import T from 'prop-types';
import theme from './styles/carouselItemBase.scss';
var CarouselItemBase = function CarouselItemBase(_ref) {
  var style = _ref.style,
    children = _ref.children,
    onClick = _ref.onClick;
  return onClick ? /*#__PURE__*/React.createElement("button", {
    className: theme.reset,
    onClick: onClick,
    style: style
  }, children) : /*#__PURE__*/React.createElement("div", {
    style: style
  }, children);
};
CarouselItemBase.propTypes = {
  children: T.node,
  onClick: T.func,
  style: T.object
};
export default CarouselItemBase;